fragment TrialInfo on Instance {
    shouldShowChatCta
    isDuringNutshellBusinessHours
    isChatHidden
}
